import { restApiClient } from '@/datasources';

export const getAvailableDates = async ({ id }: { id: string }) => {
  const { data } = await restApiClient.get<{ date: string }[]>(
    `/online/customers/appointments/${id}/reschedule-available-dates/`,
  );

  return data;
};
